import type { components } from "@majitap/sdk";
import { queryOptions } from "@tanstack/react-query";
import { api, errorOf } from "./api";

export type Incident = components["schemas"]["Incident"];
export type IncidentType = components["schemas"]["IncidentType"];

export const incidentTypesQuery = queryOptions({
  queryKey: ["incident-types"],
  staleTime: 60_000,
  queryFn: async () => {
    const { data, error } = await api.GET("/v1/admin/incidents/types");
    if (error || !data) throw errorOf(error);
    return data.data;
  },
});

/** A type's code from its name: "Customer not home" → "customer_not_home" (the API's `^[a-z][a-z0-9_]{1,47}$`). */
export function codeFromName(name: string): string {
  const code = name
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^[^a-z]+|_+$/g, "")
    .slice(0, 48);
  return code.length >= 2 ? code : "";
}

export const incidentActions = {
  report: async (body: { delivery_id: string; type_code: string; notes?: string }) => {
    const { data, error } = await api.POST("/v1/admin/incidents", { body });
    if (error || !data) throw errorOf(error);
    return data;
  },
  resolve: async (id: string, resolution_notes: string) => {
    const { data, error } = await api.POST("/v1/admin/incidents/{id}/resolve", {
      params: { path: { id } },
      body: { resolution_notes },
    });
    if (error || !data) throw errorOf(error);
    return data;
  },
  addType: async (body: { code: string; name: string; description?: string }) => {
    const { data, error } = await api.POST("/v1/admin/incidents/types", { body });
    if (error || !data) throw errorOf(error);
    return data;
  },
  updateType: async (id: string, body: { name?: string; description?: string; is_active?: boolean }) => {
    const { data, error } = await api.PATCH("/v1/admin/incidents/types/{id}", { params: { path: { id } }, body });
    if (error || !data) throw errorOf(error);
    return data;
  },
};
